import { Readable } from './Product/Readable';
import { Variant } from './Product/Variant';
import { Category } from './Category';
import dayjs from 'dayjs';
import Dinero from 'dinero.js';
import Log from '../Kodansha/Services/Logger';
import { VariantType } from './CartItem';
var Product = /** @class */ (function () {
    function Product() {
        this.thumbnails = [];
        this.creators = [];
    }
    Product.prototype.creatorsToString = function () {
        if (!this.creators || this.creators.length < 0) {
            return null;
        }
        return this.creators.map(function (x) { return x.name; }).join(",");
    };
    //Components.Bundler Bundler
    Product.prototype.toApi = function () {
        var _a, _b;
        return Object.assign({}, this, {
            variants: (_a = this.variants) === null || _a === void 0 ? void 0 : _a.map(function (v) { return v.toApi(); }),
            category: this.category.name,
            categoryId: this.category.Id,
            publishDate: this.publishDate.toISOString(),
            readable: (_b = this.readable) === null || _b === void 0 ? void 0 : _b.toApi(),
            chapters: this.chapters.map(function (x) { return x.toApi(); })
        });
    };
    Product.createFromApi = function (dto) {
        var _a, _b, _c;
        return Object.assign(new Product(), dto, {
            variants: (_a = dto.variants) === null || _a === void 0 ? void 0 : _a.map(function (x) { return Variant.createFromApi(x); }),
            category: Category.createFromApi(dto.categoryId, dto.category),
            publishDate: dayjs(dto.publishDate),
            readable: Readable.createFromApi(dto.readable),
            chapters: (_c = (_b = dto.chapters) === null || _b === void 0 ? void 0 : _b.map(function (x) { return Product.createFromApi(x); })) !== null && _c !== void 0 ? _c : [],
        });
    };
    Product.prototype.lowestPrice = function () {
        var prices = this.variants.map(function (x) { return x.price; });
        return Dinero.minimum(prices);
    };
    Product.prototype.canReadDigitalByUser = function (userIsLoggedIn) {
        var _a;
        if (this.readable.isOwned) {
            return true;
        }
        var digitalPriceType = (_a = this.getDigitalVariant()) === null || _a === void 0 ? void 0 : _a.priceType;
        return digitalPriceType === 'Free'
            || digitalPriceType === 'FreeToReadAndPurchaseble'
            || (userIsLoggedIn && digitalPriceType === 'FreeForRegistered')
            || (userIsLoggedIn && digitalPriceType === 'FreeToReadForRegisteredAndPurchaseble');
    };
    Product.prototype.canReadDigitalByAnyUser = function () {
        var _a;
        var digitalPriceType = (_a = this.getDigitalVariant()) === null || _a === void 0 ? void 0 : _a.priceType;
        return digitalPriceType === 'Free'
            || digitalPriceType === 'FreeToReadAndPurchaseble'
            || digitalPriceType === 'FreeForRegistered'
            || digitalPriceType === 'FreeToReadForRegisteredAndPurchaseble';
    };
    Product.prototype.canDigitalBePurchased = function (userIsLoggedIn) {
        var _a;
        if (this.readable.isOwned) {
            return false;
        }
        var digitalPriceType = (_a = this.getDigitalVariant()) === null || _a === void 0 ? void 0 : _a.priceType;
        return digitalPriceType === 'Paid'
            || (userIsLoggedIn && digitalPriceType === 'FreeToReadAndPurchaseble')
            || (userIsLoggedIn && digitalPriceType === 'FreeToReadForRegisteredAndPurchaseble');
    };
    Product.prototype.getDigitalVariant = function () {
        var _a;
        if (((_a = this.variants) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var digitalVariants = this.variants.filter(function (x) { return x.type === 'Digital'; });
            if (digitalVariants.length > 0) {
                return digitalVariants[0];
            }
        }
        return null;
    };
    Product.prototype.getDefaultVariant = function () {
        var _a;
        if (((_a = this.variants) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return this.variants[0];
        }
        Log.warn("Product ".concat(this.id, " ::: ").concat(this.name, " has no variants!"));
        console.log(this);
        return null;
    };
    Product.prototype.getPrintVariant = function () {
        var _a, _b;
        if (((_a = this.variants) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var variants = (_b = this.variants) === null || _b === void 0 ? void 0 : _b.filter(function (x) { return x.type === VariantType.Print; });
            if (variants.length > 0)
                return variants[0];
            else
                return null;
        }
        return null;
    };
    Product.prototype.hasChapters = function () {
        var _a, _b;
        return (_b = (((_a = this.chapters) === null || _a === void 0 ? void 0 : _a.length) > 0)) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * For Volumes, the series, otherwise, the Trilogy Name.
     */
    Product.prototype.getName = function () {
        if (this.subCategory === "Volume") {
            return this.series.title;
        }
        return this.name;
    };
    /**
     * For volumes, the Volume Number, otherwise null
     */
    Product.prototype.getSubName = function () {
        if (this.subCategory === "Volume") {
            return "Volume ".concat(this.volumeNumber);
        }
        return null;
    };
    return Product;
}());
export { Product };
